import React from "react";

import GenericTable from "../TableWrapper.jsx";

import { GENERIC_LOADING_STRING } from "../../../../constants.js";

/**
 * @typedef {any} DataEntry
 */

/**
 * Generic table component that maps a data array to components
 *
 * @param {Object} props
 * @param {string} [props.id] id of table
 * @param {string} [props.summary] summary of table
 * @param {string} [props.caption] caption content
 * @param {boolean} [props.condensed=true] include 'table-condensed' in className string?
 * @param {DataEntry[]} props.data
 * @param {function(DataEntry): React.JSX.Element} props.mapper
 * @param {boolean} [props.loading=false] content is loading
 * @param {string} [props.loadingMessage=GENERIC_LOADING_STRING] message to display when loading
 * @param {string} [props.emptyMessage="No results found"] message to display when data array is empty
 * @param {React.ReactNode} [props.children]
 * @returns {React.JSX.Element}
 */
export default function Table({
  id,
  className,
  summary,
  caption,
  condensed = true,
  data,
  mapper,
  loading = false,
  loadingMessage = GENERIC_LOADING_STRING,
  emptyMessage = "No results found",
  children,
}) {
  if (loading) {
    return <div style={{ textAlign: "center" }}>{loadingMessage}</div>;
  } else if (data && data.length === 0) {
    return (
      <GenericTable id={id} className={className} summary={summary} caption={caption} condensed={condensed}>
        {children}
        <tbody>
          <tr>
            <th role="row" colSpan="100" className="col-xs-12 text-center">
              {emptyMessage}
            </th>
          </tr>
        </tbody>
      </GenericTable>
    );
  } else {
    return (
      <GenericTable id={id} className={className} summary={summary} caption={caption} condensed={condensed}>
        {children}
        <tbody>{data.map((item) => mapper(item))}</tbody>
      </GenericTable>
    );
  }
}
